import React from "react";
import { BlogPostAuthor } from "../utils/types";
import { fullUserName } from "../utils/functions";
import { ProfileImage } from "./ProfileImage";
import FootnoteText from "./FootnoteText";
import styled from "styled-components";

export const AuthorProfile = ({
  style,
  additionalFootnoteText,
  author,
  textTabIndex,
}: {
  style?: React.CSSProperties;
  author: BlogPostAuthor;
  additionalFootnoteText?: string;
  textTabIndex?: number;
}): JSX.Element => (
  <ProfileRow style={style}>
    <ProfileImage
      altText=""
      fluidImage={
        author &&
        author.profile_image &&
        author.profile_image.childImageSharp.fluid
          ? author.profile_image.childImageSharp.fluid
          : null
      }
    />
    <FootnoteText
      style={{ margin: "0 0 0 5px" }}
      tabIndex={textTabIndex}
    >{` · ${fullUserName(author)} ${
      additionalFootnoteText || ""
    }`}</FootnoteText>
  </ProfileRow>
);
const ProfileRow = styled.div`
  display: flex;
  align-items: center;
  flex-warp: wrap;
`;
